import type { AxiosInstance, AxiosResponse } from 'axios';
import type { VypisyudajuSouboryUlozkaDto } from '../generated';
import type { RequestData } from '../types/queryTypes';

export const extractOfDataQuery =
	(axiosInstance: AxiosInstance) =>
	async <Params, Body>({
		body,
		params,
	}: RequestData<Params, Body>): Promise<AxiosResponse<void, void>> =>
		axiosInstance.post('/api/v1/vypisyudaju/odeslatZadost', body, {
			params,
		});

export const extractOfDataGetFileIdQuery =
	(axiosInstance: AxiosInstance) =>
	async <Body, Params>({
		body,
		params,
	}: RequestData<Params, Body>): Promise<
		AxiosResponse<VypisyudajuSouboryUlozkaDto>
	> =>
		axiosInstance.post('/api/v1/vypisyudaju', body, {
			params,
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
